<template>
  <div class="medication-request-view">



    <div>
      <form v-loading="generatingMedicationRequest" element-loading-text="Generando Prescripción..." @submit.prevent="handleFormSubmit">
        <h5 :class="(isCheque ? 'cheque-request' : 'medication-request') + '-view__title'">
          Ingresar Prescripción
        </h5>
        <div class="medication-request-view__content">
           <button type = "button" class = "btn btn-add float-right" style="margin-top:-20px" v-on:click="backdialog = true">Regresar al menú principal</button>
          <div class="medication-request-view__content-column">
            Información Prescriptor

            <hr>
            <address-input v-model="requester.address" errors-prefix="requester" :errors="errors" />
          </div>
          <div class="medication-request-view__content-column">
            Información del Paciente
            <hr>
            <medication-request-patient-info-foreigs :value="subject" :errors="errors" @input="handlePatientInfoInput" />
          </div>
          <div class="medication-request-view__content-column">
            Medicamentos
            <hr>
            <medication-list
              v-if="canAddMedications"
              :medications="medicationRequests"
              @delete-medications="handleDeleteMedication"
              @edit-medication="handleEditMedication"
              @add-medication="handleAddMedication" />
            <div v-else class="alert alert-warning text-center">
              Ingrese la información del paciente para continuar
            </div>
          </div>
        </div>
        <div class="medication-request-view__footer mt-4">
          <button type="submit" :disabled="disableGeneratePrescription" class="btn btn-submit">
            Generar Prescripción
          </button>
        </div>
      </form>
    </div>
    <el-dialog
      title="Ingresar Medicamento"
      width="80%"
      custom-class="medication-request-form__dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="showMedicationRequestFormDialog"
      :before-close="handleCloseMedicationRequestFormDialog">
      <medication-request-form
        v-if="activeMedicationRequest"
        :medication-request="activeMedicationRequest"
        :errors="activeMedicationDispenseErrors"
        :requested="medicationRequests"
        @submit="handleMedicationRequestFormSubmit" />
    </el-dialog>

    <el-dialog
      title="Error"
      width="60%"
      :before-close="handleClosePrescripcionError"
      custom-class="medication-request-form__dialog"
      :visible="prescripcionError != ''">
      {{prescripcionError}}

    </el-dialog>

    <el-dialog
      title="Regresar al menú principal"
      width="30%"
      :before-close="handleCloseBack"
      custom-class="medication-request-form__dialog css-personalizado-volver"
      :visible="backdialog">
      <div class = "row">
        <div class = "col-md-12">
          ¿Está seguro de volver atrás?, se perderá toda la información.
        </div>
        <div class = "col-md-12 mt-3">
          <div class = "row">
            <div class = "col-md-2"></div>
            <div class = "col-md-4 col-6">
              <button class="btn btn-add btn-responsive" style="word-break: keep-all;" @click="handleCloseBack()">
                <strong>Cancelar</strong>
              </button>
            </div>
            <div class = "col-md-4 col-6">
              <button class="btn btn-submit btn-add btn-responsive" style="word-break: keep-all;width:120px;" @click="$router.go(-1)">
                <strong v-if="getWidth() > 300">Ir al Menú</strong>
                <strong v-else>Regresar</strong>
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import fhirPatientFactory from '@/fhir-definitions/patient';
import fhirMedicationRequestFactory from '@/fhir-definitions/medication-request';
import MedicationRequestPatientInfoForeigs from '@/components/medication/MedicationRequestPatientInfoForeigs';
import MedicationList from '@/components/medication/MedicationList';
import MedicationRequestForm from '@/components/medication/MedicationRequestForm';
import nanoId from '@/helpers/nanoid';
import _set from 'lodash/set';
import _get from 'lodash/get';
import AddressInput from '@/components/medication/AddressInput';
import dayjs from 'dayjs';

const requiresLegalRepresentative = function(date) {
  if (!date) return false;
  return dayjs(date, 'YYYY-MM-DD') > dayjs().subtract(18, 'year');
};

export default {
  name: 'MedicationRequestView',
  components: { AddressInput, MedicationList, MedicationRequestPatientInfoForeigs, MedicationRequestForm },
  data() {
    return {
      medicationRequests: [],
      subject: fhirPatientFactory(),
      requester: this.$store.getters.requesterResource,
      showMedicationRequestFormDialog: false,
      activeMedicationRequest: null,
      activeMedicationDispenseErrors: {},
      fetchingMedicationsMetadata: false,
      generatingMedicationRequest: false,
      prescripcionError : '',
      backdialog : false,
      errors: {}
    };
  },
  computed: {
    isCheque(){
      return process.env.VUE_APP_RECETA_CHEQUE == 'true';
    },
    canAddMedications() {
      return _get(this.subject, 'name.given') !== '' && _get(this.subject, 'name.family') !== '';
    },
    disableGeneratePrescription() {

      return (
        this.medicationRequests.length <= 0
      );
    }
  },
  created() {
    this.fetchMedicationsMetadata();
  },
  methods: {
    getWidth(){
      return document.body.clientWidth;
    },
    requiresLegalRepresentative(birthdate) {
      return requiresLegalRepresentative(birthdate);
    },
    fetchMedicationsMetadata() {
      this.fetchingMedicationsMetadata = true;
      this.$store.dispatch('fetchMedicationsMetadata')
        .finally(() => {
          this.fetchingMedicationsMetadata = false;
        });
    },
    handleCloseMedicationRequestFormDialog() {
      this.activeMedicationRequest = null;
      this.showMedicationRequestFormDialog = false;
      this.activeMedicationDispenseErrors = {};
    },
    handleMedicationRequestFormSubmit(medicationRequest) {
      this.$store.dispatch('validateMedicationRequestForm', {
        ...medicationRequest,
        subject: this.subject,
        requester: this.requester
      })
        .then(() => {
          let medicationRequestItem = {
            id: medicationRequest.id,
            data: medicationRequest
          };
          this.medicationRequests = [...this.medicationRequests.filter(m => m.id !== medicationRequest.id), ...[medicationRequestItem]];
          this.handleCloseMedicationRequestFormDialog();
        })
        .catch(e => {
          if (_get(e, 'response.data', []).length) {
            this.activeMedicationDispenseErrors = this.prepareValidationResponse(e.response.data);
          } else {
            this.activeMedicationDispenseErrors = {
              form: 'Ha ocurrido un error al intentar ingresar el medicamento'
            };
          }
        });
    },
    prepareValidationResponse(errorMessages) {
      const preparedErrors = {};
      errorMessages.forEach(e => {
        preparedErrors[e.field] = e.message;
      });
      return preparedErrors;
    },
    handleAddMedication() {
      this.activeMedicationRequest = fhirMedicationRequestFactory({ id: nanoId() });
      this.showMedicationRequestFormDialog = true;
    },
    handleEditMedication(medication) {
      this.activeMedicationRequest = medication;
      this.showMedicationRequestFormDialog = true;
    },
    handleDeleteMedication(selectedMedicationsIds) {
      for (let selectedMedicationId of selectedMedicationsIds) {
        let index = this.medicationRequests.findIndex(m => m.id === selectedMedicationId);
        this.medicationRequests.splice(index, 1);
      }
    },
    handleFormSubmit(event) {
      this.generatingMedicationRequest = true;
      this.$store.dispatch('generateMedicationRequestForeig', {
        medicationRequests: this.medicationRequests,
        subject: this.subject,
        requester: this.requester
      })
        .then(response => {
          let groupId = _get(response, 'data.contained[0].group_id');
          this.$router.push(`/medication-requests/${groupId}`);
        })
        .catch(errors => {
          let errorKeys = Object.keys(errors);
          if (errorKeys.length == 0){
            this.prescripcionError = 'Hubo un problema al generar la prescripción. Favor intente más tarde.';
            return;
          }
          console.log('errores:', Object.keys(errors));
          this.errors = errors;
        })
        .finally(() => {
          this.generatingMedicationRequest = false;
        });
    },
    parseValues(request) {
      var parsedData = request;
      const keysToParse = [
        'data.dosageInstruction[0].timing.repeat.period',
        'data.dosageInstruction[0].timing.repeat.boundsDuration.value',
        'data.dosageInstruction[0].doseAndRate[0].doseQuantity.value'
      ];
      keysToParse.forEach(key => {
        let element = _get(request, key, 0);
        _set(parsedData, key, this.convertToNumber(element));
      });
      return parsedData;
    },
    convertToNumber(value) {
      if (!isNaN(value)) return value;
      return Number(value.replace(',', '.'));
    },
    handlePatientInfoInput(field, value) {
      _set(this.subject, field, value);
      this.$set(this, 'subject', JSON.parse(JSON.stringify(this.subject)));
    },
    handleClosePrescripcionError(){
      this.prescripcionError = '';
    },
    handleCloseBack(){
      this.backdialog = false;
    },
    goback(){
      window.location.href = '/';
    }
  }
};
</script>
<style lang="scss">

.medication-request-view__title {
  color: $--color-white;
  margin: 0 0 $--spacing-4 0;
}

.cheque-request-view__title {
  color: $--color-black;
  margin: 0 0 $--spacing-4 0;
}

.medication-request-view {
  margin-top: $--spacing-4;

  &__content {
    background-color: $--color-white;
    border-radius: $--border-radius-base;
    padding: $--spacing-lg;

    &-column {
      flex: 1;

      &:first-child {
        padding-right: $--spacing-4;
      }
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }
}

.css-personalizado-volver {
  @media (max-width: 500px){
      width: 80% !important;
      padding-left:10px;
      padding-right: 10px;
      padding-bottom:10px;
    }
}

.btn-responsive {
  @media (max-width: 500px){
    width: 110% !important;
    font-size:small;
    margin-left: -2%;
  }

  @media (max-width: 300px){
    font-size:x-small;
    width: 120% !important;
    margin-left: -10%;
  }

}



</style>
